import { StyleSheet, View } from "react-native";
import Text from "@components/CustomText";
import React from "react";
import color from "@constants/color";
import OrderStatus from "@assets/svg/OrderStatus";

interface FooterData {
  title?: string;
  subtitle?: string;
  body?: string;
  title_color?: string;
}

interface IssueFooterProps {
  footer?: FooterData;
}

const IssueFooter: React.FC<IssueFooterProps> = ({ footer }) => {
  return (
    <View style={styles.footer}>
      <OrderStatus
        orderStatus="RequestApproved"
        orderStatusColor={footer?.title_color}
      />
      <View style={{ marginLeft: 8 }}>
        {footer?.title ? (
          <Text
            variant="body_text_4"
            style={{
              color: footer?.title_color,
            }}
          >
            {footer?.title}
          </Text>
        ) : null}
        {footer?.subtitle ? (
          <Text
            variant="body_text_3"
            style={{
              color: color.mediumBlack,
            }}
          >
            {footer?.subtitle}
          </Text>
        ) : null}
        {footer?.body ? (
          <Text
            variant="caption_2"
            style={{
              color: color.mediumBlacklightBlack,
            }}
          >
            {footer?.body}
          </Text>
        ) : null}
      </View>
    </View>
  );
};

export default IssueFooter;

const styles = StyleSheet.create({
  footer: {
    flexDirection: "row",
    backgroundColor: "rgba(253, 243, 226, 1)",
    padding: 16,
    alignItems: "flex-start",
  },
});
